import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { VaultAccountStatusType, VaultAccountType } from '@/types/myVaultTypes';

export type UpdateVaultAccountStatusPayloadType = { status: VaultAccountStatusType; code?: string };
export type UpdateVaultAccountStatusResponseType = VaultAccountType & { links_revoked?: number };

export const updateVaultAccountStatusApi = (
  id: string,
  data: UpdateVaultAccountStatusPayloadType
): Promise<ApiResponseType<UpdateVaultAccountStatusResponseType>> => {
  return authApiService.PATCH(`/my-vault/accounts/${id}/status/`, data);
};
